import { useRef } from 'react';
import Modal from 'react-bootstrap/Modal';
import AppButton from '../atoms/AppButton';
import NestedItemsManager from './NestedItemsManager';

/**
 * Submodal para gerenciar itens filhos (variações, adicionais) fora do modal
 * principal — empilhados no mesmo corpo, eles transformavam o formulário do
 * produto numa página de rolagem longa.
 *
 * As classes `nested-modal*` elevam o z-index acima do modal que fica atrás
 * (o padrão do Bootstrap é o mesmo para os dois, e o segundo ficaria embaixo).
 */
function NestedItemsModal({ show, onHide, title, subtitle, ...managerProps }) {
  const managerRef = useRef(null);

  // "Concluído" (e também X, ESC e clique fora, que passam pelo mesmo onHide
  // do Modal) fechavam direto, mesmo com uma edição ou um item novo com dados
  // digitados e ainda não salvos — o rascunho sumia sem aviso. Antes de
  // fechar, tenta salvar o que estiver pendente; só fecha se não houver nada
  // pendente ou se o salvamento deu certo.
  async function handleRequestClose() {
    const canClose = await managerRef.current?.flush?.();
    if (canClose !== false) onHide();
  }

  return (
    <Modal
      show={show}
      onHide={handleRequestClose}
      centered
      scrollable
      fullscreen="md-down"
      className="nested-modal"
      backdropClassName="nested-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: '20px 24px' }}>
        {subtitle && (
          <p className="mb-3" style={{ fontSize: 12.5, color: '#888' }}>{subtitle}</p>
        )}
        <NestedItemsManager ref={managerRef} {...managerProps} />
      </Modal.Body>

      <Modal.Footer>
        <AppButton variant="ghost" onClick={handleRequestClose}>Concluído</AppButton>
      </Modal.Footer>
    </Modal>
  );
}

export default NestedItemsModal;
